const CSS_CLASSES = {
	DATE: 'select--date',
	CONTAINER_DATE: 'select--date__container--hor',
};

export { CSS_CLASSES };
